import { useMutation, useQuery } from 'react-query';
import message from 'antd/es/message';

import { request, L2TxReqParams, queryClient, useCurrentUserId, toastError } from '@/utils';
import { updateUserDetailQuery, useUpdateCurrentAddressInfo } from '@/hooks';

export type Web3IdGiftOrder = {
  id: string;
  receiver: UserInfo;
  buyer: UserInfo;
  is_minted: boolean;
};

export const usePostWeb3IdGift = (addr: string) => {
  const mutation = useMutation(
    ({ receiverId, tx }: { receiverId: string; tx: L2TxReqParams }) => {
      return request
        .post<{ is_success: boolean }>('/web3_id_gift/create', {
          tx,
          receiver_id: receiverId,
        })
        .then(res => {
          if (res.is_success) {
            invalidWeb3IdGift(receiverId);
            message.success('success');
          }
          return res;
        });
    },
    {
      onError(err) {
        toastError(err);
      },
    },
  );

  return mutation;
};
export const useMintWeb3IdGift = () => {
  const address = useCurrentUserId();
  const update = useUpdateCurrentAddressInfo();

  const mutation = useMutation(({ web3_id }: { web3_id: string }) => {
    return request
      .post<{ is_success: boolean }>('/web3_id_gift/mint', {
        web3_id,
      })
      .then(res => {
        if (res.is_success) {
          invalidWeb3IdGift(address!);

          updateUserDetailQuery({
            id: address!,
            account_id: web3_id,
          });

          update(pre => {
            const next = { ...pre };
            if (next.detail) {
              next.detail = {
                ...next.detail,
                account_id: web3_id,
              };
            }

            if (next.userInfo?.desc) {
              next.userInfo = {
                ...next.userInfo,
                desc: {
                  ...next.userInfo.desc,
                  user: {
                    ...next.userInfo.desc.user,
                    web3_id,
                  },
                },
              };
            }

            return next;
          });
          message.success('success');
        }
        return res;
      });
  });

  return mutation;
};

export const useWeb3IdGiftQuery = (id: string) => {
  return useQuery(['/web3_id_gift', id], () => {
    return request.get<{
      web3_id_gift: Web3IdGiftOrder;
    }>('/web3_id_gift', {
      receiver_id: id,
    });
  });
};

export const invalidWeb3IdGift = (id: string) => {
  queryClient.invalidateQueries(['/web3_id_gift', id]);
};
